import { render } from "./ChatMessageFile.vue?vue&type=template&id=22463310&scoped=true&ts=true"
import script from "./ChatMessageFile.vue?vue&type=script&lang=ts"
export * from "./ChatMessageFile.vue?vue&type=script&lang=ts"

import "./ChatMessageFile.vue?vue&type=style&index=0&id=22463310&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22463310"]])

export default __exports__